// Session / localStorage at-rest encryption, shared by both front ends (ARCH-17).
//
// Moved verbatim from web/cashbook/src/utils/Encodepassword.js so that the blob one app writes is
// the blob the other reads. The key and IV come from the build-time environment; both apps must
// define the same values, or a session started in one is unreadable in the other.
import typeCode from 'crypto-js'

function encryptSession(json) {
    var cipher = typeCode.AES.encrypt(JSON.stringify(json), typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_KEY_SESSION), {
        iv: typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_IV_SESSION),
        mode: typeCode.mode.CBC
        });
    return cipher.toString()
}

function decryptSession(code) {
    var cipher = typeCode.AES.decrypt(code, typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_KEY_SESSION), {
        iv: typeCode.enc.Utf8.parse(process.env.VUE_APP_AES_IV_SESSION),
        mode: typeCode.mode.CBC
        });
    return typeCode.enc.Utf8.stringify(cipher).toString()
}

export {
    encryptSession,
    decryptSession,
}
